import { shallow } from "zustand/shallow";

import { type TopLevelDataObj } from "@hsl/fund-explorer/types";

import useExplorerStore from "../store/store";

function useShareClasses(shareClasses: string[]): TopLevelDataObj[] {
    const { refinedData, getShareClassById } = useExplorerStore(
        ({ refinedData, getShareClassById }) => ({
            refinedData,
            getShareClassById,
        }),
        shallow,
    );
    const availableShareclasses = shareClasses.filter((sc) =>
        refinedData.shareClasses.includes(sc),
    );
    const shareClassData = availableShareclasses
        .map(getShareClassById)
        .map((x) => x?.data) as unknown as TopLevelDataObj[];

    return shareClassData;
}

export default useShareClasses;
